<woa-modal-page-layout [title]="'woa.heading.invoice.title'">
    <woa-form (onSubmit)="requestInvoice()">
        <woa-email-field [(ngModel)]="email" name="email"
                         [label]="'woa.label.payment.taxInvoiceEmailAddress'" required woa-email></woa-email-field>
    </woa-form>
    <woa-button woa-page-footer-control [label]="'woa.button.invoice.send'" [disabled]="sending()"
                (onActivate)="form().submit()"></woa-button>
</woa-modal-page-layout>
